import 'trade-in/components/TradeInCta/TradeInCtaItem/TradeInCtaItem.scss';

import React from 'react';
import PropTypes from 'prop-types';

const TradeInCtaItem = ({ classesName, dataTest, onClick, buttonText, content }) => {
    const classes = classesName.join(' ');

    const wrapper = (
        <div className="TradeInCtaItem__wrapper is-light is-small" data-test={dataTest}>
            <button className={`is-wide ${classes}`} onClick={onClick}>
                {buttonText}
            </button>
            {/* fprovost: Hiding the description until the part 2 of the trade-in. @see https://jira.sm360.ca/browse/SHOWROOM-3106 */
            false && <div className="TradeInCtaItem__list" dangerouslySetInnerHTML={content} />}
        </div>
    );
    return wrapper;
};

TradeInCtaItem.defaultProps = {
    dataTest: '',
};

TradeInCtaItem.propTypes = {
    classesName: PropTypes.arrayOf(PropTypes.string).isRequired,
    dataTest: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    buttonText: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
};

TradeInCtaItem.displayName = 'TradeInCtaItem';

export default TradeInCtaItem;



// WEBPACK FOOTER //
// ./src/components/TradeInCta/TradeInCtaItem/TradeInCtaItem.jsx